import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../../api/quarkusApi';

export function useAnamnesisIds(patientId) {
  const navigate = useNavigate();

  const [anamnesisIds, setAnamnesisIds] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAnamnesisIds = useCallback(() => {
    if (!patientId) {
      return;
    }
    setLoading(true);
    quarkusApi
      .get(`/patients/${patientId}/anamnesis-ids`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .then((returnFromApi) => setAnamnesisIds(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [patientId, navigate]);

  useEffect(() => {
    fetchAnamnesisIds();
  }, [fetchAnamnesisIds]);

  return { anamnesisIds, isLoading, error, refetch: fetchAnamnesisIds };
}
